<template>
  <v-card :color="area.fl_realizada ? '#90EE90' : '#FFFFE0'" class="mx-4 mt-4">
    <v-row align-content="space-between">
      <v-col cols="6">
        <v-card-title>
          <AreaConcentracaoBugs
            :id="area.id_area_concentracao"
            :descricao="area.descricao"
            :index="index"
            :csu="csu"
          ></AreaConcentracaoBugs>
        </v-card-title>
      </v-col>

      <v-col cols="6">
        <v-card-actions class="d-flex justify-end">
          <div>
            <EditAreaConcentracao
              v-if="isQA"
              @area-concentracao-editada="
                (id) => this.$emit('areaConcentracaoEditada', id)
              "
              :id="area.id_area_concentracao"
            />
          </div>
          <div class="mx-3">
            <DeleteAreaConcentracao
              v-if="isQA"
              @area-concentracao-removida="
                (id) => this.$emit('areaConcentracaoRemovida', id)
              "
              :id="area.id_area_concentracao"
            />
          </div>
        </v-card-actions>
      </v-col>
    </v-row>

    <v-card-text class="mt-2">
      <div class="text-h6 mb-4">Realizada</div>
      <p class="font-weight-bold">{{ area.fl_realizada ? 'Sim' : 'Não' }}</p>
    </v-card-text>

    <v-card-text class="mt-2">
      <div class="text-h6 mb-4">Descrição</div>
      <p class="font-weight-bold">{{ area.descricao }}</p>
    </v-card-text>
  </v-card>
</template>

<script>
/* eslint-disable */
import EditAreaConcentracao from './dialogs/EditAreaConcentracao.vue';
import DeleteAreaConcentracao from './dialogs/DeleteAreaConcentracao.vue';
import AreaConcentracaoBugs from './dialogs/AreaConcentracaoBugs.vue';

export default {
  props: {
    area: Object,
    index: Number,
    csu: Object,
  },
  components: {
    EditAreaConcentracao,
    DeleteAreaConcentracao,
    AreaConcentracaoBugs,
  },
  computed: {
    isQA() {
      return localStorage.getItem('formaAtuacao') === '"TESTADOR"';
    },
  },
};
</script>
